import * as New from './amrApiNew';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import * as Old from './amrApiOld';

const AmrApi = (getFeature('my-office-iframe') === 'https://amr.mrgcdn.ru/v13/') ? New.AmrEditApi : Old;

export default AmrApi;